module.exports = __webpack_public_path__ + "static/7-39c97ba699478ea9e6f7a31b3807089a.jpeg";